<template>
  <div class="col-12">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('teachers.add_teacher_title') }}
            </h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2 ">
        <div class="row justify-content-center">
          <div class="col-12">
            <TeacherForm 
              ref="teacherForm"
              :title="$t('teachers.add_teacher_title')"
              :submit-text="$t('teachers.submit_teacher')"
              :isLoading="isSubmitting"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
             <div class="d-flex gap-3 mt-3 ms-3">
              <button
                type="submit"
                class="btn btn-primary btn-sm flex-grow-1"
                :disabled="isSubmitting"
                @click.prevent="submitForm"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin ms-2"></i>
                  {{ $t('teachers.saving') }}
                </span>
                <span v-else>
                  <i class="fas fa-save ms-2"></i>
                  {{ $t('teachers.submit_teacher') }}
                </span>
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times ms-2"></i>
                {{ $t('teachers.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TeacherForm from '@/components/features/teachers/TeacherForm.vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const toast = useToast();
const router = useRouter();
const store = useStore();
const teacherForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  if (!teacherForm.value) return;
  
  // Validate form before submission
  const isValid = await teacherForm.value.validateForm();
  if (!isValid) {
    toast.warning(t("teachers.validation_warning"));
    isSubmitting.value = false;
    return;
  }

  try {
    await store.dispatch('teacher/createTeacher', formData);
    toast.success(t("teachers.added_successfully"));
    router.push('/teachers');
  } catch (error) {
    if (error.response?.status === 422) {
      const errors = error.response.data.errors;
      for (const field in errors) {
        toast.error(errors[field][0]);
      }
    } else {
      toast.error(error.response?.data?.message || t("teachers.add_error"));
    }
  } finally {
    isSubmitting.value = false;
  }
};

const submitForm = () => {
  isSubmitting.value = true;
  teacherForm.value?.submitForm();
};

const handleValidationError = () => {
  isSubmitting.value = false;
  toast.warning(t("teachers.validation_warning"));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/teachers');
  }
};
</script>